/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const file_csv_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 23H2.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646V9"
    />
    <path
      fill="#000"
      d="M7.562 15.5c0-1.39.48-2.3 1.23-2.3.64 0 .98.38 1.08 1.21l1.39-.49c-.21-1.28-1.09-2.02-2.4-2.02-1.76 0-2.83 1.36-2.83 3.6 0 2.28 1.04 3.6 2.83 3.6 1.23 0 2.01-.56 2.43-1.75l-1.25-.69c-.25.87-.54 1.14-1.23 1.14-.8 0-1.25-.83-1.25-2.3Zm7.286 3.6c1.54 0 2.51-.83 2.51-2.15 0-1.04-.64-1.73-1.95-2.08l-.67-.18c-.6-.16-.83-.38-.83-.8 0-.45.39-.75.98-.75.51 0 .92.33 1.02.84l1.28-.6c-.18-.88-1.12-1.48-2.32-1.48-1.44 0-2.46.87-2.46 2.08 0 1.05.61 1.72 1.87 2.06l.67.18c.67.18.91.42.91.87 0 .48-.38.77-1.01.77-.64 0-.98-.29-1.32-1.15l-1.25.73c.37 1.11 1.23 1.66 2.57 1.66Zm7.486-7.1-1.3 5.15-1.31-5.15h-1.57l2.14 7h1.42l2.14-7h-1.52Z"
    />
  </svg>
)
export default file_csv_medium
